export const buildGemCandidateLink = (mergeRemoteId: string): string => {
  return `https://www.gem.com/candidate/${mergeRemoteId}/profile`;
};

export const buildGemPositionLink = (mergeRemoteId: string): string => {
  return `https://www.gem.com/ats/jobs/${mergeRemoteId}/candidates`;
};
